goog.provide("shadow.js.shim.module$$mui$material$Breadcrumbs");
goog.provide("module$shadow_js_shim_module$$mui$material$Breadcrumbs");
shadow.js.shim.module$$mui$material$Breadcrumbs = shadow.js.nativeProvides["@mui/material/Breadcrumbs"] = shadow$bridge("@mui/material/Breadcrumbs");
module$shadow_js_shim_module$$mui$material$Breadcrumbs.default = shadow.js.shim.module$$mui$material$Breadcrumbs;
